import { PageRef } from 'providers/page-ref';
import { FitnessPlan } from '@cf-shared/data-model/fitness-plan';
import { FitnessState } from '@cf-shared/data-model/user-state';
import { Loading } from 'providers/loading-controller';
import { ResolvedProgram } from './workout-plan-scanner-mapping';
import { WorkoutPlanApplyMode } from './workout-plan-scanner-apply';

export type WorkoutPlanScannerPageParams = {
  returnCallback?: string;
  local?: {
    /** The edit-workouts DRAFT plan. NOTE: NavController `local` params are JSON
     *  deep copies (sessionStorage), NOT live references — the scanner only READS
     *  this copy (already-in-plan flags, slot derivation). The reviewed program is
     *  returned via the pop result and edit-workouts applies it to its live draft. */
    fitnessPlan?: FitnessPlan;
    /** The edit-workouts DRAFT fitness state — read-only copy, see above. */
    fitnessState?: FitnessState;
  };
};

export type WorkoutPlanScannerPageResult = {
  /** true when the user confirmed Apply on a reviewed program. */
  applied: boolean;
  /** the reviewed program — the CALLER applies it to its live draft (the scanner
   *  cannot: its draft is a sessionStorage copy, see WorkoutPlanScannerPageParams) */
  program?: ResolvedProgram;
  /** append-vs-replace, chosen in the alert shown when Apply is pressed */
  mode?: WorkoutPlanApplyMode;
  /** a global loading overlay the SCANNER presented (synchronously, before popping) so
   *  the spinner is already on screen during the back-transition — there is no flash of
   *  the pre-apply plan. edit-workouts DISMISSES it once the apply finishes. Passed by
   *  in-memory reference (the pop result is not serialized), so the singleton
   *  LoadingController's overlay survives the scanner's destruction. */
  loading?: Loading;
};

export const IWorkoutPlanScannerPage: PageRef<WorkoutPlanScannerPageParams, WorkoutPlanScannerPageResult> = {
  pageName: 'WorkoutPlanScannerPage',
} as PageRef<WorkoutPlanScannerPageParams, WorkoutPlanScannerPageResult>;
